import type { BatchingObjectData } from '@powerplay/core-minigames'
/**
 * Trieda pre konfig batching objektov
 */
export const batchingConfig: Map<string, BatchingObjectData> = new Map([

])
